import { render } from "./CookAndMeInCookPageComponent.vue?vue&type=template&id=ccc9dcf8"
import script from "./CookAndMeInCookPageComponent.vue?vue&type=script&lang=js"
export * from "./CookAndMeInCookPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__